import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class ProfileResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.canUpdateVendorProfile = false;
    }
    get() {
        return `${this.firstName} ${this.lastName}`;
    }
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return `${this.urlRoot}/CurrentUserProfile`;
    }
    static updateProfile() {
        return this.update().extend({
            url: () => `${this.urlRoot}/UpdateProfile`
        });
    }
}
ProfileResource.urlRoot = legacyApiResourceUrl("VulcanData");
//# sourceMappingURL=ProfileResource.js.map